import React from "react";
import { Link } from "react-router-dom";
import { INFO } from "../../core/site";

/** The home link in the bar: the first name in accent, the rest in ink, upper case. */
const NavLogo = () => {
	const [first, ...rest] = INFO.main.name.toUpperCase().split(" ");
	return (
		<Link
			to="/"
			className="font-sligoil font-bold text-xl text-pp-ink transition-colors duration-150 inline-flex items-center min-h-6"
		>
			<span className="text-pp-accent">{first}</span>
			{/* The link is a flex container, which drops a whitespace-only text node, so
			    the word space must travel with the surname as a real character. */}
			<span>{" " + rest.join(" ")}</span>
		</Link>
	);
};

export default NavLogo;
